<template>
  <div id="LoginLayout">
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
